module.exports = __webpack_public_path__ + "img/img4.23ea8194.jpg";